module.exports = __webpack_public_path__ + "files/791f8368099a411f126f5c2ea3b2d910.png";